import React from 'react';
import { X } from 'lucide-react';

interface CreditsModalProps {
    onClose: () => void;
}

export function CreditsModal({ onClose }: CreditsModalProps) {
    return (
        <div className="absolute inset-0 bg-black/60 flex items-center justify-center pointer-events-auto z-50">
            <div className="bg-gray-800 p-8 rounded-xl shadow-2xl text-white border-2 border-gray-700 w-full max-w-md relative">
                <button onClick={onClose} className="absolute top-4 right-4 text-gray-400 hover:text-white">
                    <X size={28} />
                </button>
                <h2 className="text-4xl font-bold mb-8 text-center">Credits</h2>
                
                <p className="text-center text-xl">
                    Developed by Alex Luna using Graph
                </p>

                <div className="mt-10 text-center">
                    <button
                        onClick={onClose}
                        className="bg-yellow-500 hover:bg-yellow-600 text-gray-900 font-bold py-2 px-8 rounded-lg text-xl transition-transform transform hover:scale-105"
                    >
                        Back
                    </button>
                </div>
            </div>
        </div>
    );
}
